import { ChartMetadata, ChartPlugin, t } from '@superset-ui/core';
import buildQuery from './buildQuery';
import controlPanel from './controlPanel';
import transformProps from './transformProps';
import { CalendarChartTransformedProps } from './types';
import thumbnail from './images/thumbnail.png';

export default class CustomCalendarChartPlugin extends ChartPlugin<CalendarChartTransformedProps> {
  constructor() {
    super({
      buildQuery,
      controlPanel,
      loadChart: () => import('./Chart'),
      metadata: new ChartMetadata({
        name: t('Custom Calendar Chart'),
        description: t(
          'Calendar grid. First dimension is date by day. Second dimension is label in cell. First metric is optional value.',
        ),
        category: t('Other'),
        tags: [t('Calendar'), t('Grid'), t('Custom')],
        thumbnail,
      }),
      transformProps,
    });
  }
}
